import { useTranslation } from "react-i18next";
import { ArrowUp } from "lucide-react";

interface GalleryBannerProps {
  count: number;
  onRefresh: () => void;
}

export function GalleryBanner({ count, onRefresh }: GalleryBannerProps) {
  const { t } = useTranslation();

  if (count <= 0) return null;

  return (
    <button
      onClick={onRefresh}
      className="sticky top-0 z-20 flex w-full items-center justify-center gap-2 bg-primary/90 px-4 py-2.5 text-sm font-medium text-white shadow-md backdrop-blur-sm transition-all hover:bg-primary cursor-pointer"
    >
      <ArrowUp className="h-4 w-4" />
      <span>{t("activity.galleryBanner", { count })}</span>
    </button>
  );
}
